import { Component, ElementRef, OnDestroy, ViewChild, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Photo } from '../../shared/models/photo';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'ldw-capture-photo-dialog',
    templateUrl: './capture-photo-dialog.component.html',
    styleUrls: ['./capture-photo-dialog.component.css'],
    standalone: false
})
export class CapturePhotoDialogComponent implements OnDestroy {
  dialogRef = inject<MatDialogRef<CapturePhotoDialogComponent, Photo>>(MatDialogRef);
  private translateService = inject(TranslateService);

  cameras: MediaDeviceInfo[] = []
  @ViewChild('video') private _video: ElementRef<HTMLVideoElement> | undefined;
  @ViewChild('canvas') private _canvas: ElementRef<HTMLCanvasElement> | undefined;
  errorMessage = "";
  width: number = 640;
  canvasWidth: number = 640;
  height: number = 480;
  canvasHeight: number = 480;
  photo: Photo | undefined;
  selectedCamera: MediaDeviceInfo | undefined

  constructor() {
    this.init();

  }
  ngOnDestroy(): void {
    (this._video?.nativeElement.srcObject as MediaStream)?.getTracks().forEach(track => track.stop());
  }

  async init() {
    const devices = await navigator.mediaDevices.enumerateDevices()
    this.cameras = devices.filter(device => device.kind === 'videoinput')
    const storedDeviceId = window.localStorage.getItem('livedokWeb.SelectedCamera');
    if(!storedDeviceId) {
      return;
    }
    this.selectedCamera = devices.find(device => device.deviceId === storedDeviceId);
    if(this.selectedCamera) {
      this.switchCamera(this.selectedCamera);
    }
  }

  async switchCamera(camera: MediaDeviceInfo) {
    this.errorMessage = "";
    if(!this._video) {
      return;
    }
    window.localStorage.setItem('livedokWeb.SelectedCamera', camera.deviceId);
    try {
    this._video.nativeElement.srcObject = await navigator.mediaDevices.getUserMedia({video: {deviceId: camera.deviceId}})
    this._video.nativeElement.play()
    } catch (_) {
      this.errorMessage = this.translateService.instant('MESSAGES.DLG_CAMERA_ERROR');
    }
  }

  capture() {
    if(!this._canvas?.nativeElement || !this._video?.nativeElement) {
      return;
    }
    this.canvasWidth = this._video?.nativeElement.videoWidth
    this.canvasHeight = this._video?.nativeElement.videoHeight
    this._canvas.nativeElement.width = this.canvasWidth;
    this._canvas.nativeElement.height = this.canvasHeight;
    this._video?.nativeElement.pause();


    this._canvas?.nativeElement?.getContext('2d')?.drawImage(this._video?.nativeElement, 0, 0);

    const photo = {
      data: this._canvas.nativeElement.toDataURL('image/png'),
      width: this.canvasWidth,
      height: this.canvasHeight}

      console.log(photo);
      this.photo = photo;
  }

  abort() {
    this.dialogRef.close(undefined);
  }

  paste() {
    this.dialogRef.close(this.photo)
  }

  release() {
    this.photo = undefined
    this._video?.nativeElement.play();
  }
}
